import React from 'react';
import { Box, Typography } from '@mui/material';
import { isJSON, parseJSONCleaned } from 'utilities/index';

const GenerateOutPutFromObject = ({
  output,
  transformReference,
}: {
  output: Record<string, string>;
  transformReference?: (promptString: string) => React.ReactNode;
}) => {
  return (
    <Box paddingBottom={1}>
      {Object.entries(output || {}).map(([key, value]) => {
        if (typeof value === 'object') {
          return (
            <Box key={key}>
              <Typography
                component='span'
                padding='2px'
                borderRadius={1}
                bgcolor={(theme) => theme.palette.primary.light}
                className='spark_test_search_element'
              >
                {key}
              </Typography>
              <Box marginLeft={1}>
                <GenerateOutPutFromObject
                  output={value as Record<string, string>}
                />
              </Box>
            </Box>
          );
        }

        return (
          <Box marginTop={1} key={key}>
            <Typography
              component='span'
              padding='2px'
              borderRadius={1}
              bgcolor={(theme) => theme.palette.primary.light}
              className='spark_test_search_element'
            >
              {key}
            </Typography>
            <Typography
              marginLeft={1}
              component='span'
              noWrap={false}
              textAlign='justify'
              className='spark_test_search_element'
              whiteSpace='pre-wrap'
            >
              {transformReference ? transformReference(value) : value}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

type SparkGenerateOutputProps = {
  output: string | undefined;
  transformReference?: (promptString: string) => React.ReactNode;
};
function SparkGenerateOutput({
  output,
  transformReference,
}: SparkGenerateOutputProps) {
  if (!output) {
    return <></>;
  }
  if (isJSON(output)) {
    const parseJSON = parseJSONCleaned<Record<string, string>>(output);
    if (!parseJSON) {
      return <></>;
    }
    return (
      <GenerateOutPutFromObject
        output={parseJSON}
        transformReference={transformReference}
      />
    );
  }

  return (
    <Box className='spark_test_search_element spark-content' paddingBottom={1}>
      {output}
    </Box>
  );
}

export default SparkGenerateOutput;
